import Repository from '../../../../../foundation/repository/Repository';
import ApiData from '../../../../../foundation/repository/ApiData';
import User from '../../../users/domain/aggregates/user/User';
import LessonResult from '../aggregates/lessonResult/LessonResult';
import Lesson from '../aggregates/lesson/Lesson';
import EntityId from '../../../../../foundation/domain/EntityId';

export default class LessonResultRepository extends Repository<LessonResult> {

	public getByUserIdAndLessonId (userId: EntityId<User>, lessonId: EntityId<Lesson>) {
		return this.getAll().find(lessonResult => lessonResult.getUserId().equals(userId) && lessonResult.getLessonId().equals(lessonId));
	}

	public mapObject (data: ApiData) {
		return new LessonResult(
			data.id<LessonResult>('id'),
			data.id<User>('userId'),
			data.id<Lesson>('lessonId'),
			data.number('progress'),
			data.timepointOrNull('completedTimepoint')
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/repositories/LessonResultRepository.ts